<h2>Tag Colors</h2>

<div class="button-grid">
	<div class="button-column">
		<span class="label">YELLOW</span>
		<app-tag label="Pendiente" color="yellow" />
		<app-ui-code-block [code]="generateCode({label: 'Pendiente', color: 'yellow'})" />
	</div>

	<div class="button-column">
		<span class="label">BLUE</span>
		<app-tag label="En progreso" color="blue" />
		<app-ui-code-block [code]="generateCode({label: 'En progreso', color: 'blue'})" />
	</div>

	<div class="button-column">
		<span class="label">GREEN</span>
		<app-tag label="Completado" color="green" />
		<app-ui-code-block [code]="generateCode({label: 'Completado', color: 'green'})" />
	</div>

	<div class="button-column">
		<span class="label">RED</span>
		<app-tag label="Bloqueado" color="red" />
		<app-ui-code-block [code]="generateCode({label: 'Bloqueado', color: 'red'})" />
	</div>

	<div class="button-column">
		<span class="label">GRAY</span>
		<app-tag label="Inactivo" color="gray" />
		<app-ui-code-block [code]="generateCode({label: 'Inactivo', color: 'gray'})" />
	</div>
</div>

<h2>Tag Sizes</h2>

<div class="size-grid">
	<div class="size-column">
		<span class="label">Large</span>
		<app-tag label="Large Tag" color="green" size="large" />
		<app-ui-code-block [code]="generateCode({label: 'Large Tag', color: 'green', size: 'large'})" />
	</div>

	<div class="size-column">
		<span class="label">Small</span>
		<app-tag label="Small Tag" color="yellow" size="small" />
		<app-ui-code-block [code]="generateCode({label: 'Small Tag', color: 'yellow', size: 'small'})" />
	</div>
</div>
